<template>
  <v-container fluid>
    <VueApexCharts
      width="100%"
      height="300"
      type="bar"
      :options="options"
      :series="series"
    />
  </v-container>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: 'ChartGautiMenuo',
  components: {
    VueApexCharts,
  },
  props: {
    chart: Object,
    laikotarpis: String,
  },
  data() {
    return {
      //
    }
  },
  computed: {
    series() {
      return [
        {
          name: 'Gauta',
          data: [
            this.chart.hipoteka + 0,
            this.chart.ikeitimas + 0,
            this.chart.vykdomasis + 0,
            this.chart.sutartis + 0,
          ],
        },
      ]
    },
    seriesDemo() {
      return [{ name: 'Gauta', data: [30, 20, 40, 53] }]
    },
    options() {
      return {
        plotOptions: {
          bar: {
            distributed: true,
            borderRadius: 5,
            dataLabels: {
              position: 'top', // top, center, bottom
            },
          },
        },
        chart: {
          toolbar: {
            tools: {
              download: false,
            },
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function(val) {
            return val
          },
          offsetY: -20,
          style: {
            fontSize: '10px',
            colors: ['#304758'],
          },
        },
        tooltip: {
          enabled: true,
        },
        legend: {
          show: false,
        },
        xaxis: {
          categories: [
            'Hipotekos',
            'Įkeitimai',
            'Vykdomieji įrašai',
            'Sutartys',
          ],
          position: 'bottom',
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
          labels: {
            show: false,
            formatter: function(val) {
              return val
            },
          },
        },
        title: {
          text: `Gauti duomenys (${this.laikotarpis})`,
          floating: true,
          offsetY: 0,
          align: 'center',
          style: {
            color: '#444',
            fontSize: '16px',
            fontFamily: 'Open Sans',
          },
        },
      }
    },
  },
  created() {
    //
  },
  methods: {
    //
  },
}
</script>
